import { render } from "./UnauthorizedPage.vue?vue&type=template&id=1f84560f"
const script = {}

import "./UnauthorizedPage.vue?vue&type=style&index=0&id=1f84560f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__